import { getParams } from '@/utils/params';

const getBookmarkKey = () => {
  const params = getParams();
  return `designBookmarks-${params.contextId}-${params.platform.toLowerCase()}`;
};

const getFavoriteKey = () => {
  const params = getParams();
  return `designFavorites-${params.contextId}-${params.platform.toLowerCase()}`;
};

export const saveFavorites = (favorites: string[]) => {
  try {
    const key = getFavoriteKey();
    window.localStorage.setItem(key, favorites.join(';'));
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.error(e);
    }
  }
};

export const getFavorites = (): string[] => {
  const key = getFavoriteKey();
  try {
    const items = window.localStorage.getItem(key) || window.localStorage.getItem(getBookmarkKey());
    return items ? items.split(';') : [];
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.error(e);
    }
    return [];
  }
};
